/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineNotificationService() {
        let notificationService = {};
        notificationService.sendQueryEmail = function (request){
            return axios.post("/api/NotificationService/SendQueryEmail", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        return notificationService;
    }
    //define globally if it doesn't already exist
    if (typeof (notificationService) === "undefined") {
        window.notificationService = defineNotificationService();
    } else {
        console.log("notificationService already defined.");
    }
})(window);